import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'

const SelectableTariffDropdown = ({
  options = [],
  value,
  onChange,
  disabled = false,
  className = '',
  placeholder = 'Выберите опцию',
  selectedPrice = 0
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const selectedOption = options.find(option => option.value === value)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleSelect = (option) => {
    if (!disabled && !option.disabled) {
      onChange(option.value)
      setIsOpen(false)
    }
  }

  return (
    <div className={cn('relative', className)} ref={dropdownRef}>
      <div className="relative">
        <div
          className={cn(
            'w-full px-5 py-4 rounded-[16px] cursor-pointer transition-colors min-h-[86px] flex items-center border',
            {
              'bg-[#2B3135] border-transparent': !disabled,
              'bg-[#2B3135] border-white/[12%] cursor-not-allowed': disabled,
            }
          )}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex-1 pr-4">
              {selectedOption ? (
                <div>
                  <div className="text-white text-sm leading-[22px]">
                    {selectedOption.label}
                  </div>
                  <div className="text-[#FFE8AE] text-xs leading-[20px] pt-[3px]">
                    {selectedOption.price === -1
                      ? 'Персонально'
                      : selectedOption.price === 0
                        ? 'Бесплатно'
                        : `${selectedOption.price.toLocaleString('ru')} ₽`
                    }
                  </div>
                </div>
              ) : (
                <div className="text-white/60 text-sm">
                  {placeholder}
                </div>
              )}
            </div>
            <div className="ml-3">
              <svg
                className={cn(
                  'transition-transform duration-200',
                  isOpen ? 'rotate-180' : 'rotate-0'
                )}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 4.5L6 7.5L9 4.5"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-[#1B2126] border border-white/[12%] rounded-[16px] shadow-lg z-50 max-h-60 overflow-y-auto">
            {options.map((option) => (
              <div
                key={option.value}
                className={cn(
                  'px-5 py-4 cursor-pointer transition-colors border-b border-white/[7%] last:border-b-0 min-h-[86px] flex items-center',
                  {
                    'bg-[#2B3135]': value === option.value,
                    'hover:bg-[#2B3135]/50': value !== option.value && !option.disabled,
                    'cursor-not-allowed opacity-50': option.disabled
                  }
                )}
                onClick={() => handleSelect(option)}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex-1 pr-4">
                    <div className="text-white text-sm leading-[22px]">
                      {option.label}
                    </div>
                    <div className="text-[#FFE8AE] text-xs leading-[20px] pt-[3px]">
                      {option.price === -1
                        ? 'Персонально'
                        : option.price === 0
                          ? 'Бесплатно'
                          : `${option.price.toLocaleString('ru')} ₽`
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export { SelectableTariffDropdown }
